import { ReactNode } from "react";
import {
  OverlayArrow,
  Tooltip as RACTooltip,
  TooltipProps as RACTooltipProps,
} from "react-aria-components";
import { arrow, tooltipStyles } from "./tooltipBubble.css";

interface TooltipBubbleProps extends Omit<RACTooltipProps, "children"> {
  children: ReactNode;
}

/**
 * Internal primitive for rendering a tooltip overlay bubble.
 * Must be used within a TooltipTrigger component.
 */
const TooltipBubble = ({ children, ...props }: TooltipBubbleProps) => (
  <RACTooltip className={tooltipStyles} {...props}>
    <OverlayArrow>
      <svg width={8} height={8} viewBox="0 0 8 8" className={arrow}>
        <path d="M0 0 L4 4 L8 0" />
      </svg>
    </OverlayArrow>
    {children}
  </RACTooltip>
);

export default TooltipBubble;
